<template>
  <el-drawer
    title="卡片详情"
    :visible.sync="visible"
    direction="rtl"
    :before-close="handleClose"
    custom-class="c-drawer"
    size="45%"
  >
    <!--操作-->
    <div class="drawer-content">
      <el-form
        ref="formRef"
        :model="formInfo"
        :rules="formRules"
        v-loading="formLoading"
        label-position="right"
        size="small"
        label-width="120px"
      >
        <el-col :span="12">
          <el-form-item label="权益卡名称" prop="name">
            <el-input v-model="formInfo.name" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="权益卡类型" prop="type">
            <el-select
              v-model="formInfo.type"
              placeholder="请选择"
              clearable
              style="width: 100%;"
            >
              <el-option
                v-for="item in cardTypeOptions"
                :key="Number(item.value)"
                :label="item.label"
                :value="Number(item.value)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="价格/元" prop="price">
            <el-input-number
              style="width: 100%;"
              v-model="formInfo.price"
              controls-position="right"
              :precision="2"
              clearable
              :min="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="折扣" prop="discount">
            <el-input-number
              style="width: 100%;"
              v-model="formInfo.discount"
              controls-position="right"
              :precision="2"
              clearable
              max="1"
              :min="0"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效时间/天" prop="validity">
            <el-input-number
              style="width: 100%;"
              v-model="formInfo.validity"
              controls-position="right"
              clearable
              :min="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="权益" prop="privilegesList">
            <el-select
              style="width: 100%;"
              v-model="formInfo.privilegesList"
              placeholder="请选择"
              multiple
              clearable
            >
              <el-option
                v-for="item in privilegeList"
                :key="item.id + ''"
                :label="item.name"
                :value="item.id + ''"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="说明" prop="description">
            <el-input
              style="width: 100%;"
              type="textarea"
              v-model="formInfo.description"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="formInfo.status"
              placeholder="请选择"
              clearable
              style="width: 100%;"
            >
              <el-option
                v-for="item in statusOptions"
                :key="Number(item.value)"
                :label="item.label"
                :value="Number(item.value)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <div class="editOpera-seat"></div>
    <div class="drawer-footer">
      <div class="operation">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirm">保存</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { bizPrivilegePoolsList, bizPrivilegeCardSave } from "@/api/privilege";
export default {
  name: "BizPrivilegeCardInfo",
  data() {
    return {
      visible: false,
      cardTypeOptions: [],
      statusOptions: [],
      privilegeList: [],
      formInfo: {},
      formRules: {
        name: [
          { required: true, message: "请输入权益卡名称", trigger: "blur" }
        ],
        type: [
          { required: true, message: "请选择权益卡类型", trigger: "change" }
        ],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        validity: [
          { required: true, message: "请输入有效时间", trigger: "blur" }
        ]
      },
      formLoading: false
    };
  },
  created() {
    this.loadPrivilegeList();
  },
  methods: {
    loadPrivilegeList() {
      bizPrivilegePoolsList().then(resp => {
        if (resp.data.status == 100) {
          this.privilegeList = resp.data.results;
        }
      });
    },
    open(info, options) {
      this.formInfo = info || {};
      this.cardTypeOptions = options.cardTypeOptions;
      this.statusOptions = options.statusOptions;
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
      this.$refs.formRef.resetFields();
      this.formInfo = {};
    },
    handleConfirm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.saveFormData();
        }
      });
    },
    saveFormData() {
      this.formLoading = true;
      bizPrivilegeCardSave(this.formInfo)
        .then(resp => {
          if (resp.data.status == 100) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.handleClose();
            this.$emit("refresh");
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.formLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.c-drawer {
  width: 100%;
  height: 100%;
  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 16px;
    form {
      flex: 1;
    }
    //   //距离bottom
    //   .editor {
    //     height: 300px;
    //     margin-bottom: 100px;
    //   }
    //   .explain {
    //     font-size: 12px;
    //     color: #999;
    //     margin-top: 8px;
    //     line-height: 1.5;
    //   }
  }
  .editOpera-seat {
    width: 100%;
    height: 54px;
  }
  .drawer-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 4px 4px;
    z-index: 30;
    display: flex;
    /** 操作 靠右 */
    .operation {
      margin-left: auto;
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// info.vue?410aaddc